import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './locales/i18n';
import './config/plugins';
import './styles/components';

Vue.config.productionTip = false;

const requireComponent = require.context(
  '@/components/Icons',
  true,
  /index.(vue)$/,
);

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName);
  const componentName = fileName.split('/')[1];

  Vue.component(componentName, componentConfig.default || componentConfig);
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
